import { AuthObj } from '@core/models/user.model';

export class AutoLogin {
	static readonly type = '[Auth] Auto Login User';
	constructor() {}
}
export class Login {
	static readonly type = '[Auth] Login User';
	constructor(public authObj: AuthObj) {}
}
export class Logout {
	static readonly type = '[Auth] Logout User';
}
export class UpdateTwoFactorAuth {
	static readonly type = '[Auth] Update two factor auth';
	constructor(public secret: string) {}
}
export class SetupAuth {
	static readonly type = '[Auth] Setup two-factor authentication';
}
export class VerifyAuth {
	static readonly type = '[Auth] Verify two-factor authentication';
	constructor(public authCode: string) {}
}
export class DeactivateAuth {
	static readonly type = '[Auth] Deactivate two-factor authentication';
}
export class GenerateRecoveryCodes {
	static readonly type = '[Auth] Generate new recovery codes';
}
export class LoginWithRecoveryCode {
	static readonly type = '[Auth] Login with recovery code';
	constructor(public recoveryCode: string) {}
}
